import { createSlice, createSelector, createEntityAdapter } from "@reduxjs/toolkit";

const InputsAdapter = createEntityAdapter();

const inputs = [
	{id: 0, name: "rate", label: "Average Room Rate (ADR)", value: 69.00, adornment: "$"},
	{id: 1, name: "stay", label: "Average Length of Stay (Days)", value: 1.00},
	{id: 2, name: "wage", label: "Average Housekeeping Hourly Wage ($/hr)", value: 18.00, adornment: "$"},
	{id: 3, name: "minutes", label: "Average Minutes to clean (1) room", value: 30},
	{id: 4, name: "breakfast", label: "Breakfast cost per occupied room (CPOR)", value: 3.50, adornment: "$"},
	{id: 5, name: "amenities", label: "Room Amenities CPOR", value: 1.15, adornment: "$"},
	{id: 6, name: "cleaning", label: "Cleaning chemicals CPOR", value: 0.25, adornment: "$"},
	{id: 7, name: "laundry", label: "Laundry chemicals CPOR", value: 0.35, adornment: "$"},
	{id: 8, name: "utilities", label: "Utilities CPOR", value: 1.50, adornment: "$"},
	{id: 9, name: "rooms", label: "Number of rooms in group", value: 0},
	{id: 10, name: "nights", label: "Length of stay in nights", value: 0},
	{id: 11, name: "points", label: "Is the group eligible for CP Points?", value: "No", options: ["Yes", "No"]},
	{id: 12, name: "comm", label: "Is the group commissionable?", value: "No", options: ["Yes", "No"]}
];

const emptyInitialState = InputsAdapter.getInitialState();
const initialState = InputsAdapter.upsertMany(emptyInitialState, inputs);

const InputsSlice = createSlice({
	name: "inputs",
	initialState,
	reducers: {
		updateInput: InputsAdapter.updateOne
	}
})

export const {
	updateInput
} = InputsSlice.actions;

export default InputsSlice.reducer

export const { selectAll: selectInputs, selectById: selectInputById } = InputsAdapter.getSelectors(state => state.channelMix.inputs);

export const selectInputValues = createSelector(
	selectInputs,
	inputs => inputs.map(input => input)
);

export const selectLabeledInputValues = createSelector(
	selectInputs,
	inputs => inputs.reduce((a, obj) => ({ ...a, [obj.name]: obj.value}), {})
);
